/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="search" size=32 />
 */
const Search = () => (
  <>
    <path
      d="M13.9807 26.3846C20.5381 26.3846 25.8538 21.0689 25.8538 14.5116C25.8538 7.95425 20.5381 2.63849 13.9807 2.63849C7.42342 2.63849 2.10767 7.95425 2.10767 14.5116C2.10767 21.0689 7.42342 26.3846 13.9807 26.3846Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9807 3.13849C7.69957 3.13849 2.60767 8.23039 2.60767 14.5116C2.60767 20.7927 7.69957 25.8846 13.9807 25.8846C20.2619 25.8846 25.3538 20.7927 25.3538 14.5116C25.3538 8.23039 20.2619 3.13849 13.9807 3.13849ZM1.60767 14.5116C1.60767 7.6781 7.14728 2.13849 13.9807 2.13849C20.8142 2.13849 26.3538 7.6781 26.3538 14.5116C26.3538 21.345 20.8142 26.8846 13.9807 26.8846C7.14728 26.8846 1.60767 21.345 1.60767 14.5116Z"
      fill="#002D55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7687 22.6962L30.2456 30.1616L29.5391 30.8692L22.0621 23.4038L22.7687 22.6962Z"
      fill="#002D55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6459 6.62338C17.8411 6.81864 17.8411 7.13522 17.6459 7.33048L14.4959 10.4805C14.3006 10.6757 13.984 10.6757 13.7888 10.4805C13.5935 10.2852 13.5935 9.96864 13.7888 9.77337L16.9388 6.62338C17.134 6.42811 17.4506 6.42811 17.6459 6.62338Z"
      fill="#B9DEFA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.919 8.90798C20.1142 9.10324 20.1142 9.41983 19.919 9.61509L18.0266 11.5074C17.8314 11.7027 17.5148 11.7027 17.3195 11.5074C17.1243 11.3121 17.1243 10.9956 17.3195 10.8003L19.2119 8.90798C19.4071 8.71272 19.7237 8.71272 19.919 8.90798Z"
      fill="#B9DEFA"
    />
  </>
)

export default Search
